import { combineReducers } from '@reduxjs/toolkit';

import ordersProfileReducer from '../orderProfile/common/redux/reducer';

const rootOrdersReducer = combineReducers({
    ordersProfile: ordersProfileReducer,
});

export default rootOrdersReducer;
